import adk from 'service/adk'
import dponet from 'service/modules/dponet'
import guestPortal from 'service/modules/guestPortal'
import { getDaiRagResourcesBaseUrl } from 'service/env'

// Cria um cliente de chat ADK vinculado a um provedor de token.
// O getAuthToken é resolvido de forma lazy (a cada request) para evitar
// dependência circular e sempre capturar o token vigente.
const createChatClient = (getAuthToken) => {
  const { api, streamPost } = adk.create(
    getDaiRagResourcesBaseUrl(),
    getAuthToken,
  )

  const createSession = async ({ appName, ...params }) =>
    await api.post(`/apps/${appName}/sessions`, params)

  const run = async (params) => await api.post('/run', params)

  const runSSE = (params, callbacks) =>
    streamPost('/run_sse', params, callbacks)

  const listSessions = async ({ appName, ...params }) =>
    await api.get(`/apps/${appName}/sessions`, { params })

  const getSession = async ({ appName, sessionId }) =>
    await api.get(`/apps/${appName}/sessions/${sessionId}`)

  return { createSession, run, runSSE, listSessions, getSession }
}

// Cliente do usuário da plataforma DPOnet (JsonToken).
const chat = createChatClient(() => dponet.auth.getToken())

// Cliente do convidado do portal externo (GuestJsonToken). Usado pelo
// ai_inventory_guest_agent, que escopa o inventário por GuestOwnership.
const guestChat = createChatClient(() => guestPortal.auth.getToken())

export { chat, guestChat }
export default chat
